import type { IDeliveryMultiOrderItems } from "../multiCreateDeliveryAddress";
import { STORAGE_MULTI_ORDER_ITEMS } from "./consts";

interface ISetMultiOrderItemsToStorageProps {
  multiOrderItems?: IDeliveryMultiOrderItems[];
}

interface IGetMultiOrderItemsFromStorageProps {
  multiOrderItems: IDeliveryMultiOrderItems[];
  enabled: boolean;
}

export function setMultiOrderItemsToStorage({
  multiOrderItems,
}: ISetMultiOrderItemsToStorageProps) {
  localStorage.setItem(
    STORAGE_MULTI_ORDER_ITEMS,
    JSON.stringify(multiOrderItems),
  );
}

export function getMultiOrderItemsFromStorage(): IGetMultiOrderItemsFromStorageProps {
  const multiOrderItems = localStorage.getItem(STORAGE_MULTI_ORDER_ITEMS);

  if (multiOrderItems) {
    return {
      multiOrderItems: JSON.parse(multiOrderItems),
      enabled: true,
    };
  }

  return {
    multiOrderItems: [],
    enabled: false,
  };
}

export function removeMultiOrderItemsFromStorage() {
  localStorage.removeItem(STORAGE_MULTI_ORDER_ITEMS);
}
